import * as yup from "yup";
import { validationEmailField } from "./defaultValidations";

export default yup.object({
    subscribe: validationEmailField("Email"),
});